<template>
    <el-dialog title="选择嘉宾"
               :visible.sync="isShowDialog"
               width="1200px"
               :before-close="handleClose5">
        <div style="margin-top: 5px;">
            <el-row :gutter="5">
                <!--左边列表-->
                <el-col :span="24 - (usersCon.length>0?classWidth:0)">
                    <el-card class="box-card">
                        <el-row style="height: 34px; margin-bottom: 20px">
                            <el-col :span="2">
                                <p style="margin: 0; line-height: 34px">组织类型</p>
                            </el-col>
                            <el-col :span="4">
                                <el-select v-model="orgType" clearable placeholder="请选择">
                                    <el-option
                                            v-for="item in orgTypeList"
                                            :key="item.dictValue"
                                            :label="item.dictName"
                                            :value="item.dictValue">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="1">&nbsp;</el-col>
                            <el-col :span="2">
                                <p style="margin: 0; line-height: 34px">所属公司</p>
                            </el-col>
                            <el-col :span="4">
                                <el-select v-model="orgId"
                                                remote
                                                clearable
                                                filterable
                                                reserve-keyword
                                                placeholder="请输入"
                                                :remote-method="parentDealerSearch">
                                        <el-option v-for="item in parentDealerList"
                                                :key="item.orgId"
                                                :label="item.name"
                                                :value="item.orgId">
                                        </el-option>
                                    </el-select>
                            </el-col>
                            <el-col :span="1.5" style="float:right">
                                <el-button class="M-search" type="primary" @click="query()">查询</el-button>
                            </el-col>
                        </el-row>

                        <el-row style="height: 34px; margin-bottom: 20px">
                            <el-col :span="2">
                                <p style="margin: 0; line-height: 34px">用户ID</p>
                            </el-col>
                            <el-col :span="4">
                                <el-input v-model="userCode" :clearable="true" placeholder="请输入"></el-input>
                            </el-col>
                            <el-col :span="1">&nbsp;</el-col>
                            <el-col :span="2">
                                <p style="margin: 0; line-height: 34px">姓名</p>
                            </el-col>
                            <el-col :span="4">
                                <el-input v-model="userNameCn" :clearable="true" placeholder="请输入"></el-input>
                            </el-col>

                            <el-col :span="1.5" style="float:right">
                                <el-button class="el-back M-search M-margin-l" type="info" @click="resetUserCon()">重置</el-button>
                            </el-col>
                        </el-row>
                        <!-- 数据网格 -->
                        <div class="dataBox">
                            <el-table :data="userListCon"
                                      ref="multipleTableCon"
                                      highlight-current-row
                                      border
                                      row-key="userId"
                                      v-loading="dataListLoading"
                                      @select-all="singleSelectionAll"
                                      @select="singleSelection">

                                <el-table-column
                                        type="selection"
                                        header-align="center"
                                        align="center"
                                        disabled="true"
                                        width="50">
                                </el-table-column>
                                <el-table-column prop="userCode"
                                                 label="用户ID"
                                                 width="100"
                                                 header-align="center"
                                                 show-overflow-tooltip
                                                 align="center"></el-table-column>
                                <el-table-column prop="userNameCn"
                                                 label="姓名"
                                                 width="70"
                                                 header-align="center"
                                                 show-overflow-tooltip
                                                 align="center"></el-table-column>
                                <el-table-column prop="orgTypeName"
                                                 label="组织类型"
                                                 width="100"
                                                 header-align="center"
                                                 show-overflow-tooltip
                                                 align="center"></el-table-column>
                                <el-table-column prop="abbreviation"
                                                 label="所属公司简称"
                                                 width="130"
                                                 header-align="center"
                                                 show-overflow-tooltip
                                                 align="center"></el-table-column>
                                <el-table-column prop="bbaNo"
                                                 label="BBA No.(CKD)"
                                                 width="120"
                                                 header-align="center"
                                                 show-overflow-tooltip
                                                 align="center"></el-table-column>
                                <el-table-column prop="nscNo"
                                                 label="NSC No.(CBU)"
                                                 width="120"
                                                 header-align="center"
                                                 show-overflow-tooltip
                                                 align="center"></el-table-column>
                                <el-table-column prop="motherDealerBbaNo"
                                                 label="母店BBA No.(CKD)"
                                                 width="150"
                                                 header-align="center"
                                                 show-overflow-tooltip
                                                 align="center"></el-table-column>
                                <el-table-column prop="networkTypeName"
                                                 label="网点类型"
                                                 width="100"
                                                 header-align="center"
                                                 show-overflow-tooltip
                                                 align="center"></el-table-column>
                                <el-table-column prop="positionNameCn"
                                                 label="主要职位"
                                                 width="100"
                                                 header-align="center"
                                                 show-overflow-tooltip
                                                 align="center"></el-table-column>
                                <el-table-column prop="positionGroupTypeName"
                                                 label="职业团队分类"
                                                 width="110"
                                                 header-align="center"
                                                 show-overflow-tooltip
                                                 align="center"></el-table-column>
                            </el-table>
                            <el-pagination @size-change="pageSizeChangeHandleCon"
                                           @current-change="pageCurrentChangeHandleCon"
                                           :current-page="pageCon"
                                           :page-sizes="[10, 20, 50, 100]"
                                           :page-size="limitCon"
                                           style="text-align: right"
                                           layout="total, sizes, prev, pager, next, jumper"
                                           :total="totalCon">
                            </el-pagination>
                        </div>
                    </el-card>
                </el-col>

                <!--右边选择-->
                <el-col :span="usersCon.length>0?classWidth:0">
                    <el-card>
                        <div>
                            <el-form>
                                <div class="location-layout">
                                    <el-row>
                                        <el-col style="width: 60%;height: 34px" align="left">
                                            <p>已选嘉宾</p>
                                        </el-col>
                                        <el-col style="width: 40%;height: 34px">
                                            <el-button type="primary" @click="selectTheme">选 择</el-button>
                                        </el-col>
                                    </el-row>
                                </div>
                            </el-form>
                        </div>
                    </el-card>
                    <el-row :gutter="10">
                        <el-col style="margin-top: 10px !important;" v-for="tag in usersCon"
                                :key="tag.userId">
                            <el-tag show-overflow-tooltip
                                    style="width: 100%;text-align: left"
                                    :key="tag.userId"
                                    @close="handleClose4(tag)"
                                    closable>
                                <div style="width:90%;float:left;">
                                    <div :title="tag.userName+'('+tag.userCode+')'" style="float:left;width: 70%;overflow-x:hidden; overflow-y:hidden;text-overflow: ellipsis;white-space: nowrap;">
                                        {{tag.userName+"（"+tag.userCode+"）"}}</div>
                                    <el-checkbox v-if="className==='add'" v-model="tag.userType" style="margin-left: 5px;color:#1C69D3">发起人</el-checkbox>
                                </div>
                            </el-tag>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "themeGuest",
        components: {},
        props:{
            isShowDialog: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                // isShowUserCon: false,
                pageCon: 1,
                limitCon: 10,
                totalCon: 0,
                userCode: null, // 嘉宾搜索-id
                userNameCn: null, // 嘉宾搜索-姓名
                orgId: null, // 嘉宾搜索-公司
                orgType: null, // 嘉宾搜索-公司类型
                jobStatus: null, // 嘉宾搜索-用户是否离职
                userListCon: [], // 嘉宾列表
                guestUsersCon: [], // 关联的嘉宾
                usersCon: [{userId:'',userCode:'',userName:'',userType:false}], // 选择的嘉宾
                orgTypeList: [],
                parentDealerList: [],
                // 等待转圈
                dataListLoading: false,
                className:'',
                classWidth: 6
            }
        },
        computed:{

        },
        // 生命周期 - 挂载完成（可以访问DOM元素）
        activated() {
        },
        mounted() {

        },
        created(){
            this.getOrgType()
        },
        methods: {
            // 弹出嘉宾选择
            userDialog(value) {
                console.log('===查询嘉宾===',value)
                this.usersCon = JSON.parse(JSON.stringify(value.data))
                this.className = JSON.parse(JSON.stringify(value.class))
                this.classWidth = JSON.parse(JSON.stringify(value.class)) === 'add' ? 6:5
                this.jobStatus = JSON.parse(JSON.stringify(value.class)) === 'add' ? 10:null
                this.$nextTick(() => { this.$refs.multipleTableCon.clearSelection() })
                this.findUserCon()
            },
            // 分页, 每页条数
            pageSizeChangeHandleCon (val) {
                this.pageCon = 1
                this.limitCon = val
                this.findUserCon()
            },
            // 分页, 当前页
            pageCurrentChangeHandleCon (val) {
                this.pageCon = val
                this.findUserCon()
            },
            // 搜索所属公司简称
            parentDealerSearch(queryString) {
                this.$request.get('/sys/org/selectOrgList',
                {
                    name: queryString
                }).then((res, total, code, data) => {
                    this.parentDealerList = res
                    this.parentDealerList = this.parentDealerList.map(item => {
                    item['value'] = item.name
                    return item
                    })
                }).catch((err) => {
                    console.log(err)
                })
            },

            // 重置搜索
            resetUserCon() {
                this.pageCon = 1
                this.userCode = null
                this.userNameCn = null
                this.orgId = null
                this.orgType = null
                this.findUserCon()
            },
            query() {
                this.pageCon = 1
                this.findUserCon()
            },
            // 嘉宾查询
            findUserCon() {
                this.dataListLoading = true
                console.log(this.usersCon)
                this.$request
                    .get('/grow/basicuserinfo/getGuestList', {
                // /grow/basicuserinfo/getGuestList'
                        page: this.pageCon,
                        limit: this.limitCon,
                        userCode: this.userCode,
                        userNameCn: this.userNameCn,
                        orgId: this.orgId,
                        orgType: this.orgType,
                        jobStatus: this.jobStatus // 在职状态：在职
                    })
                    .then((res, total, code, data) => {
                        this.userListCon = data.data.records
                        this.totalCon = data.data.total

                        if (this.usersCon && this.userListCon) {
                            this.usersCon.forEach(data => {
                                this.userListCon.forEach(row => {
                                    if(data.userId === row.userId) {
                                        this.$nextTick(() => {
                                            this.$refs.multipleTableCon.toggleRowSelection(row, true)
                                        })
                                    }
                                })
                            })
                        }
                        if (this.userListCon) {
                            this.userListCon.forEach(data => {
                                this.orgTypeList.forEach(orgType => {
                                    if (data.orgType === orgType.dictValue) {
                                        data.orgTypeName = orgType.dictNameCn
                                    }
                                })
                                this.enums['networkType'].forEach(val=>{
                                    if (data.networkType === val.code) {
                                        data.networkTypeName = val.name
                                    }
                                })
                                this.enums['positionGroupType'].forEach(val=>{
                                    if (data.positionGroupType === val.code) {
                                        data.positionGroupTypeName = val.name
                                    }
                                })
                                if (data.motherDealerBbaNo === null) {
                                    data.motherDealerBbaNo = data.bbaNo
                                }
                            })
                        }
                        this.dataListLoading = false
                    })
                    .catch((err) => {
                        console.log(err)
                    })
            },
            // 查询组织类型集合
            getOrgType() {
                this.$request.get("/sys/commdict/getDictListByType?dictType=orgType").then(
                    r => {
                        this.orgTypeList = r
                    }
                )
            },
            // 全选
            singleSelectionAll (selection) {
                if (selection) {
                    let courseDataB = []
                    courseDataB = this.usersCon
                    if (selection.length > 0) {
                        for (var i = 0; i < selection.length; i++) {
                            let hasFlg = false
                            if (courseDataB.length > 0) {
                                for (var l = 0; l < courseDataB.length; l++) {
                                    if (courseDataB[l].userId.toString() === selection[i].userId.toString()) {
                                        hasFlg = true
                                    }
                                }
                            }
                            if (!hasFlg) {
                                this.usersCon.push(selection[i])
                            }
                        }
                    } else {
                        if (this.usersCon.length > 0) {
                            this.userListCon.forEach(item => {
                                let index = this.usersCon.findIndex(it => it.userId.toString() === item.userId.toString())
                                if (index != -1) {
                                    this.usersCon.splice(index,1)
                                }
                            })
                        }
                    }
                }
            },
            // 勾选
            singleSelection(selection,row) {
                // 判断当前点击的是打钩还是取消打钩 true 则是打勾
                let isSelected = this.isExistRow(selection, row, 'userId')
                if (isSelected) {
                    // 勾选
                    let _user = {'userId':row.userId,'userCode':row.userCode,'userName':row.userName,'userType':false}
                    this.usersCon.push(_user)
                } else {
                    // 取消勾选
                    for (let i in this.usersCon) {
                        if (this.usersCon[i].userId === row.userId) {
                            this.usersCon.splice(i, 1)
                        }
                    }
                }
                console.log(this.usersCon.length)
                console.log(row)
            },
            isExistRow: function isExistRow (arrs, row, field) {
                let flag = false
                arrs.forEach(function (item) {
                    if (row[field] === item[field]) {
                        flag = true
                    }
                })
                return flag
            },
            // 嘉宾选择
            selectTheme() {
                console.log('===选择按钮===',JSON.parse(JSON.stringify(this.usersCon)))
                this.$emit('selectGuest',JSON.parse(JSON.stringify(this.usersCon)))
                this.handleClose6()
            },
            // 关联了嘉宾的 X
            handleClose3(user) {
                console.log(user)
                this.guestUsersCon.splice(this.guestUsersCon.indexOf(user),1)
            },
            // 右边选择嘉宾的 X
            handleClose4(val) {
                for (let a = 0; a < this.userListCon.length; a++) {
                    // 这是需要用userId做判断具有唯一性
                    if (val.userId === this.userListCon[a].userId) {
                        this.$refs.multipleTableCon.toggleRowSelection(this.userListCon[a], false)// 选择当前行
                        break
                    }
                }
                this.usersCon.splice(this.usersCon.indexOf(val),1)
            },
            handleClose5(val) {
                console.log('===关闭窗口===')
                if (this.usersCon && this.usersCon.length>0) {
                    this.usersCon = []
                    this.handleClose6()
                }else {
                    this.selectTheme()
                }

            },
            // 嘉宾列表初始化
            handleClose6() {
                this.$emit('downDialog')
                this.pageCon = 1
                this.limitCon = 10
                this.totalCon = 0
                this.userCode = null
                this.userNameCn = null
                this.orgId = null
                this.orgType = null
                this.userListCon = []
            },
        }
    }

    //话题介绍对象
    function Introduce(type, content,index){
        this.introduceType = type
        this.introduceContent = content
        this.index = index
        this.videoHeadUrl = 'https://tasit.blob.core.chinacloudapi.cn/resource/8a7480997a05f56b017a139027980037cover.jpg';
    }
</script>

<style lang="scss" scoped>

</style>
